import { getRevertedStatusForTrip } from './getRevertedStatusForTrip';

export function isTripStatusRevertable(status: string) {
  try {
    return !!getRevertedStatusForTrip(status);
  } catch (error) {
    return false;
  }
}
